import { useQuery } from '@tanstack/react-query';
import * as SubscriptionService from '../../services/subscriptions';
import { useTokens } from '../auth/useTokens';
import useAppMeta from '../cycles/useAppMeta';
import queryClient from '../queryClient';

const usePlans = () => {
  const [{ data: meta, isLoading: isMetaLoading }] = useAppMeta();
  const authDetails = useTokens.getState();
  return useQuery({
    queryKey: [`plans`, `${meta.transactionType}`],
    queryFn: () =>
      SubscriptionService.getPlans({
        portfolioCode: meta.transactionType!,
        userId: authDetails.userInfo.username,
        clientId: authDetails.userInfo.broker,
      }),
    enabled: !!meta.transactionType,
  });
};

export const useBothUserPlans = () => {
  const authDetails = useTokens.getState();
  return {
    long: useQuery({
      queryKey: [`plans`, `hunter_long`],
      queryFn: () =>
        SubscriptionService.getPlans({
          portfolioCode: 'hunter_long',
          userId: authDetails.userInfo.username,
          clientId: authDetails.userInfo.broker,
        }),
    }).data,
    short: useQuery({
      queryKey: [`plans`, `hunter_short`],
      queryFn: () =>
        SubscriptionService.getPlans({
          portfolioCode: 'hunter_short',
          userId: authDetails.userInfo.username,
          clientId: authDetails.userInfo.broker,
        }),
    }).data,
    refetch: () => queryClient.refetchQueries({ queryKey: ['plans'] }),
  };
};

export default usePlans;
